// "Անուն Ազգանուն Հայրանուն": first name, surname and patronymic, skipping what is empty.
export const fullName = (person) =>
  [person?.firstname, person?.surname, person?.patronymic].filter(Boolean).join(" ");
